import { useMemo } from 'react';
import { copy } from '../copy';
import { fmtInt } from '../lib/format';
import type { Template } from '../types';

export interface TemplateCardView {
  t: Template;
  kcal: string;
  split: string;
  meta: string;
  suggested: boolean;
  mine: boolean;
}

export function useTemplatePicker(
  templates: Template[] | null,
  filter: string,
  recommendedTag: string | null,
) {
  const list = templates ?? [];
  const filters = useMemo(() => {
    const tags = Array.from(new Set(list.map(t => t.tag).filter(Boolean)));
    return ['All', ...tags];
  }, [list]);

  const filtered = useMemo(() => {
    if (!filter || filter === 'All') return list;
    return list.filter(t => t.tag === filter);
  }, [list, filter]);

  const cards = useMemo<TemplateCardView[]>(
    () =>
      filtered.map(t => {
        const meals = t.meals.length;
        const opts = t.meals.reduce((a, m) => a + m.options.length, 0);
        return {
          t,
          kcal: fmtInt(t.goal),
          split: `P ${t.pct.p} · C ${t.pct.c} · F ${t.pct.f}`,
          meta: `${meals} meals · ${opts} options`,
          suggested: !!recommendedTag && t.tag === recommendedTag,
          mine: !!t.mine,
        };
      }),
    [filtered, recommendedTag],
  );

  return { filters, cards, blankLabel: copy.tpl.blank, loadingLabel: 'Loading templates…', emptyLabel: 'No templates found' };
}
